var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3346 5.33325H16.0013C14.5868 5.33325 13.2303 5.89515 12.2301 6.89535C11.2299 7.89554 10.668 9.2521 10.668 10.6666V53.3333C10.668 54.7477 11.2299 56.1043 12.2301 57.1045C13.2303 58.1047 14.5868 58.6666 16.0013 58.6666H48.0013C49.4158 58.6666 50.7723 58.1047 51.7725 57.1045C52.7727 56.1043 53.3346 54.7477 53.3346 53.3333V21.3333L37.3346 5.33325Z",
    fill: "#E7D2FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.332 5.33325V21.3333H53.332",
    fill: "#BB87F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6654 34.6667H21.332",
    stroke: "#BB87F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6654 45.3333H21.332",
    stroke: "#BB87F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6654 24H23.9987H21.332",
    stroke: "#BB87F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadImage);
export default __webpack_public_path__ + "static/media/download-image.9ca39b453dfebd3cc6a7693de07e113d.svg";
export { ForwardRef as ReactComponent };